import type { INavigationRoute } from '../../components/sidebar/NavigationRoutes'

export const expenseFinanceMenuChildren: INavigationRoute[] = [
  {
    name: 'finance-expenses',
    displayName: 'menu.expenses',
    gate: 'expense',
    meta: {
      icon: 'receipt_long',
    },
  },
]
